import { render, staticRenderFns } from "./preDetail.vue?vue&type=template&id=39ed05da&scoped=true&"
import script from "./preDetail.vue?vue&type=script&lang=js&"
export * from "./preDetail.vue?vue&type=script&lang=js&"
import style0 from "./preDetail.vue?vue&type=style&index=0&id=39ed05da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ed05da",
  null
  
)

export default component.exports